// extracted by mini-css-extract-plugin
export default {"balanceRow":"balance-module__balanceRow__yO3Th","balanceTitle":"balance-module__balanceTitle__SSNgF","refreshButton":"balance-module__refreshButton__hqqSZ"};